var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-10 ma-5",attrs:{"id":"project-overview"}},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('v-divider',{staticClass:"mt-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }